<template>
  <el-dialog :title="(!id ? '新增' : '编辑') + title" :visible.sync="show" :append-to-body="true" :close-on-click-modal="false" class="dialog-small">
    <!-- 内容区域 -->
    <FormView ref="vForm" :labels="fromLabels" :formConfig="{ labelWidth: '140px' }"></FormView>
    <span slot="footer">
      <el-button plain @click="show = false">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="btnloadSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formSubMerchant } from '@/configs/forms'
export default {
  data() {
    return {
      btnloadSubmit: false,
      id: null,
      show: false,
      title: '子账号',
      fromLabels: formSubMerchant,
      detail: {}
    }
  },
  methods: {
    // 数据清空
    clear() {
      this.id = null
      this.detail = {}
    },
    open(obj) {
      this.clear()
      this.getRoles()
      if (obj && obj.userId) {
        // 编辑
        const { userId, roleId, mobile, userName } = obj
        this.id = userId
        this.detail = { userId, roleId, mobile, userName }
      } else {
        // 添加
      }
      this.show = true
      this.$nextTick(() => {
        this.$refs.vForm.fillData(this.detail)
      })
    },
    // 获取角色列表
    async getRoles() {
      const res = await this.$api.GetMerchantSystemRoleSelectList()
      const options = (res.list || []).map((item) => {
        return {
          label: item.roleName,
          key: item.roleId
        }
      })
      this.$set(this.fromLabels[2], 'options', options)
    },
    // 提交
    async submit() {
      // 结果更新
      const params = await this.$refs.vForm.getForm()
      this.btnloadSubmit = true
      if (this.id) {
        // 编辑
        const res = await this.$api.EditMerchantChildUser(params).finally(() => {
          this.btnloadSubmit = false
        })
        this.$message.success('编辑成功')
      } else {
        // 添加
        const res = await this.$api.AddMerchantChildUser(params).finally(() => {
          this.btnloadSubmit = false
        })
        this.$message.success('新增成功')
      }
      this.$emit('submit')
      this.show = false
    }
  }
}
</script>
